/* eslint-disable react/display-name */
import React from "react";
import { useUserMenu } from "react-admin";
import LogoutIcon from "@mui/icons-material/Logout";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";

import useAuthMutations from "../../store/mutations/useAuthMutations";
import { EnvType } from "../../constants/common";

const LogoutMenuItem = React.forwardRef<HTMLLIElement, React.ComponentPropsWithoutRef<typeof MenuItem>>(
  (props, ref) => {
    const { VITE_APP_SENTRY_NODE_ENV } = import.meta.env;

    const actions = useUserMenu();
    const { signOut } = useAuthMutations();

    const logout = () => {
      actions?.onClose();
      signOut();
    };

    const createSentryError = () => {
      throw new Error("This is test sentry error!");
    };

    return (
      <>
        <MenuItem onClick={logout} ref={ref} {...props}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
        {VITE_APP_SENTRY_NODE_ENV !== EnvType.PROD && (
          <MenuItem onClick={createSentryError}>
            <ListItemText>Sentry Error</ListItemText>
          </MenuItem>
        )}
      </>
    );
  }
);

export default LogoutMenuItem;
